import { Injectable, Inject, InjectionToken } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { environment } from 'src/environments/environment';

export const MIXPANEL_TOKEN = new InjectionToken<string>('MIXPANEL_TOKEN');

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  enabled = false;

  constructor(@Inject(MIXPANEL_TOKEN) private token: string) {
    if (token != null && token !== '') {
      this.enabled = true;
      mixpanel.init(this.token, {
          debug: environment.mixpanelDebug,
          autotrack: true,
          autocapture: {
                  pageview: "full-url",
                  click: true,
                  input: true,
                  scroll: false,
                  submit: true,
                  capture_text_content: true,
          },
          // record 100% of users , we may change this later if there's a lot of users
          record_sessions_percent: 100,
          record_mask_text_selector: '',
          record_block_selector: ''
      });
    }
  }

  identify(userId: string) {
    if (this.enabled) {
      mixpanel.identify(userId);
    }
  }

  setUserProperties(properties: { [key: string]: unknown }) {
    if (this.enabled) {
      mixpanel.people.set(properties);
    }
  }

  track(event: string, properties?: { [key: string]: unknown }) {
    if (this.enabled) {
      mixpanel.track(event, properties);
    }
  }

  reset() {
    if (this.enabled) {
      mixpanel.reset();
    }
  }
}